// CookieConsentDialog.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  Typography,
  Link,
  useTheme,
} from "@mui/material";
import CookieIcon from "@mui/icons-material/Cookie";

export default function CookieConsentDialog() {
  const theme = useTheme();
  const [open, setOpen] = useState(
    localStorage.getItem("cookiesAccepted") !== "true"
  );

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setOpen(false);
    loadGoogleAnalytics();
  };

  const handleReject = () => {
    localStorage.setItem("cookiesAccepted", "false");
    setOpen(false);
  };

  useEffect(() => {
    if (localStorage.getItem("cookiesAccepted") === "true") {
      loadGoogleAnalytics();
    }
  }, []);

  const loadGoogleAnalytics = () => {
    if (!window.gtag) {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-NG2YGKH83E"; // <-- Replace
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", "G-NG2YGKH83E"); // <-- Replace
    }
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: 4,
          padding: 2,
          backgroundColor: theme.palette.background.paper,
          boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
        },
      }}
    >
      <Box display="flex" alignItems="center" gap={1} p={2}>
        <CookieIcon fontSize="large" color="warning" />
        <DialogTitle sx={{ padding: 0 }}>We Value Your Privacy</DialogTitle>
      </Box>

      <DialogContent>
        <DialogContentText>
          We use cookies to enhance your browsing experience and analyze our
          traffic. You can choose to accept or reject analytics tracking.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={handleReject} color="error">
          Reject
        </Button>
        <Button onClick={handleAccept} variant="contained" color="primary">
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}
